module.exports = __webpack_public_path__ + "img/level-up.74ee879e.png";